import { Component, Inject, OnInit } from '@angular/core';
import { SetupUndercarriageService } from '../../../../../app/modules/setup-undercarriage/setup-undercarriage.service';
import { ShoeSize,ComponentGrouser } from '../../../../../app/entities';
import { ComponentDetails } from '../../../../../app/modules/manage-equipment/models/manage-equipment.model';

import { ManageEquipmentService } from '../../../../../app/modules/manage-equipment/manage-equipment.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShoeInformationAdd } from '../../../../../app/modules/action/action-models';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-add-shoe-info',
  templateUrl: './add-shoe-info.component.html',
  styleUrls: ['./add-shoe-info.component.scss']
})
export class AddShoeInfoComponent implements OnInit {

  constructor(
    private _setupService: SetupUndercarriageService,
    public dialogRef: MatDialogRef<AddShoeInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _manageEquipmentService: ManageEquipmentService,private notification: NotificationsService,
  ) { }
  _availableShoeSizes: ShoeSize[] = [];
  _availableCleanerholes: ShoeSize[] = [];
  Component:ComponentDetails;
  _availableGrousers: ComponentGrouser[] = [{ Id: 0, Title: 'Unknown' }, { Id: 1, Title: 'Single Grouser' }, { Id: 2, Title: 'Double Grouser' }, { Id: 3, Title: 'Triple Grouser' }, { Id: 4, Title: 'Self Cleaning' }];
  ShoeSize:number=0;
  GrouserId:number=0;
  CleanerHolesId:number=0;

  ngOnInit() {
    this.Component = this._data.Component;
    
    this._setupService.getShoeSizeList().subscribe(result => {
      this._availableShoeSizes = result;
  });

  //new code CleanewHOles

  this._setupService.getCleanerHolesList().subscribe(result => {
      this._availableCleanerholes = result;
  });
  


  this.ShoeSize =this.Component.ShoeSize;
  this.GrouserId =this.Component.GrouserId;
  this.CleanerHolesId =this.Component.CleanerHolesId;

  }
  ShoeInformationAdd:  ShoeInformationAdd=new ShoeInformationAdd();
  Save(){
    this.ShoeInformationAdd.EqunitId=this.Component.Id;
    this.ShoeInformationAdd.ShoeId=this.ShoeSize;
    this.ShoeInformationAdd.GrouserId=this.GrouserId;
    this.ShoeInformationAdd.CleanerHolesId=this.CleanerHolesId==0?null:this.CleanerHolesId;
    this._manageEquipmentService.addShoeInformation(this.ShoeInformationAdd).subscribe(result=>{
      if(result==1){
        this.notification.success("Shoe data saved successfully.")
      }
    })
    ///this.dialogRef.close(this.Component);
  }

  onNoClick(){
    this.dialogRef.close(null);
  }

}
